module.exports = "<div class=\"footer\">\n    <app-modal-cancel-button (click)=\"onCloseModal()\"></app-modal-cancel-button>\n</div>\n"